import messagesReader from '@upa/i18n/reader';

export default defineI18nLocale(
  async (code): Promise<object> => messagesReader(code),
);
